import { Link } from "react-router-dom";
import type { VenueSummary } from "../domain/models";
import { Price, Rating, Tag } from "./ui";
export function VenueCard({
  venue,
  compact = false,
  onSelect,
}: {
  venue: VenueSummary;
  compact?: boolean;
  onSelect?: (v: VenueSummary) => void;
}) {
  const content = (
    <>
      <img src={venue.image} alt="" />
      <div className="venue-card__body">
        <div className="row row--between">
          <div>
            <h3>{venue.venueName}</h3>
            <p>
              {venue.branchName} ·{" "}
              {venue.activityCategories[0]?.replaceAll("_", " ")}
            </p>
          </div>
          {venue.rating > 0 && <Rating value={venue.rating} />}
        </div>
        <div className="row row--wrap">
          <Price band={venue.priceBand} />
          <Tag tone={venue.isOpen ? "success" : "neutral"}>
            {venue.isOpen ? "Open now" : "Hours unavailable"}
          </Tag>
          <Tag tone={venue.hasRequestToBook ? "warning" : "accent"}>
            {venue.hasRequestToBook
              ? "Request to book"
              : "Walk-in / no booking"}
          </Tag>
        </div>
      </div>
    </>
  );
  return onSelect ? (
    <button
      className={`venue-card ${compact ? "compact" : ""}`}
      onClick={() => onSelect(venue)}
    >
      {content}
    </button>
  ) : (
    <Link
      className={`venue-card ${compact ? "compact" : ""}`}
      to={`/venues/${venue.id}`}
    >
      {content}
    </Link>
  );
}
